import { computed } from 'zustand-middleware-computed-state';
import { create, StoreApi } from 'zustand';

import { authService } from '../services/auth.service';
import { userService } from '../services/user.service';

import { getCookie, IUser, ENVIRONMENT } from 'shared';

interface Store {
  user: null | IUser;
  isLoaded: boolean;
  isAuthLoad: boolean;
  authModal: boolean;
  noCreditsModal: boolean;
  apiKey: string | undefined;
  agentKey: string | undefined;
}

export interface UserStoreAction {
  regenerateApiKey: () => Promise<void>;
  me: () => Promise<void>;
  refreshToken: () => Promise<void>;
  setAuthModal: (state: boolean) => void;
  setNoCreditsModal: (state: boolean) => void;
  toggleCreateAccModal: () => void;
  updateAuthStore: (key: string, value: any) => void;
}

interface ComputedStore {
  isAuth: boolean;
}

export const useAuthStore = create<Store & UserStoreAction & ComputedStore>(
  computed<Store & UserStoreAction, ComputedStore>(
    (
      set: StoreApi<Store & UserStoreAction>['setState'],
      get: StoreApi<Store & UserStoreAction>['getState']
    ) =>
      ({
        toggleCreateAccModal: () => {},
        updateAuthStore: (key, value) => {
          set({ [key]: value });
        },
        user: null,
        isLoaded: false,
        authModal: false,
        noCreditsModal: false,
        isAuthLoad: false,
        apiKey: undefined,
        agentKey: undefined,
        setAuthModal: (value) => {
          set({ authModal: value });
        },
        setNoCreditsModal: (value) => {
          set({ noCreditsModal: value });
        },
        me: async () => {
          const user = await userService.me();
          set({
            user
          });
        },
        regenerateApiKey: async () => {
          await userService.regenerateApiKey();
          await get().me();
        },
        refreshToken: async () => {
          await authService.refreshToken();
        }
      } as Store & UserStoreAction),
    (state) => ({
      isAuth: getCookie(`${ENVIRONMENT}2_yepic_access_token`) !== null
    })
  )
);
